import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HomeRoutingModule } from "./home-routing.module";
import { HomeComponent } from "./home.component";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';

@NgModule({
    imports: [
      CommonModule,
      HomeRoutingModule,
      NgbModule,
      FormsModule,
      TranslateModule.forChild()
    ],
    declarations: [HomeComponent]
  })
  export class HomeModule { }